import { render, staticRenderFns } from "./CodingRequestProCoderDetails.vue?vue&type=template&id=2898916c&scoped=true&"
import script from "./CodingRequestProCoderDetails.vue?vue&type=script&lang=js&"
export * from "./CodingRequestProCoderDetails.vue?vue&type=script&lang=js&"
import style0 from "./CodingRequestProCoderDetails.vue?vue&type=style&index=0&id=2898916c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2898916c",
  null
  
)

export default component.exports